export default __webpack_public_path__ + "/dist/images/logo11.jpg";